// extracted by mini-css-extract-plugin
export default {"pagiGrid":"styles_pagiGrid__gEeyn","pagiHead":"styles_pagiHead__S2qeX","pagiLine":"styles_pagiLine__-yPhA","pagiFoot":"styles_pagiFoot__owxsH"};